import React, { FC, useMemo } from 'react';

import { useTicketTable } from './useTicketTable';
import { ITicketTableProps } from '../constants/ticketlist.interface';
import Table from '../../../../components/common/react-table/Table';
import { SortOrder } from '../../../../constants/common.constants';

export const TicketTable: FC<ITicketTableProps> = props => {
    const {
        tickets,
        searchCriteria,
        ticketsCount,
        pageSortInfo,
        setPageSortInfo,
        onRowSelect,
        onCompleteTicketOpen,
        onCompleteVerifyTicketOpen,
        onReassignTicketOpen,
        onCancelTicketOpen,
        onReopenTicketOpen,
        isAdvanceSearch,
        viewTicketPermission,
    } = props;

    const { columns, onPagination, onSort } = useTicketTable({
        pageSortInfo,
        setPageSortInfo,
        onCompleteTicketOpen,
        onCompleteVerifyTicketOpen,
        onReassignTicketOpen,
        onCancelTicketOpen,
        onReopenTicketOpen,
        isAdvanceSearch,
        viewTicketPermission,
    });

    const visibleColumns = useMemo(() => {
        return columns.filter(column => column.show !== false);
    }, [columns]);

    return (
        <Table
            id="tickets"
            variant="striped"
            columns={visibleColumns}
            data={tickets}
            rowsPerPage={searchCriteria.pageSize}
            totalCount={ticketsCount}
            onPagination={onPagination}
            selectedPage={searchCriteria.startRecord / searchCriteria.pageSize + 1}
            onSortChange={onSort}
            sortById={searchCriteria.sortBy}
            sortDesc={searchCriteria.sortOrder === SortOrder.DESC}
            disableSortRemove={true}
            allowSort
            manualSortBy
            hasPagination
            onRowSelect={onRowSelect}
        />
    );
};
